/*
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-08-21 17:38:48
 * @LastEditors: game.pluto.com 66291979@qq.com
 * @LastEditTime: 2024-09-19 18:01:59
 * @FilePath: /lobby/src/stores/deposit.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { defineStore } from 'pinia'
import { useUserStore } from '@/stores/user.js'
import { post } from '@/common/request.js'
import { url } from '@/common/config.js'

export const useDepositStore = defineStore('deposit', {
  state: () => {
    return {
      bannersHomeTop: []
    }
  },
  getters: {
    country() {
      return useUserStore().country
    },
    userInfo() {
      return useUserStore().userInfo
    }
  },
  actions: {
    requestConfig() {
      return post(url.recharge.config)
    },
    createOrder(param, account, bankCode, otpCode, routing) {
      return new Promise((resolve, reject) => {
        post(url.recharge.create, param)
          .then(({ id }) => {
            // account, bankCode, id, payChannel
            post(url.recharge.prepay, {
              account,
              bankCode, //: 'cbebirr',
              id,
              payChannel: param.payChannel, //: 'santimPay',
              otpCode,
              routing
            })
              .then((response) => {
                resolve({ response, id })
              })
              .catch((err) => {
                reject(err)
              })
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    createOrderForKE(param) {
      return new Promise((resolve, reject) => {
        post(url.recharge.create, param)
          .then(({ id, fee }) => {
            // account, bankCode, id, payChannel
            resolve({ id, fee })
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    prepay({ id, payChannel, account, bankCode, otpCode, routing }) {
      return post(url.recharge.prepay, {
        account,
        bankCode, //: 'cbebirr',
        id,
        payChannel, //: 'santimPay',
        otpCode,
        routing
      })
      // .then((response) => {
      //   resolve(response)
      // })
      // .catch((err) => {
      //   reject(err)
      // })
    },
    queryPay(id) {
      return post(url.recharge.querypay, { id: parseInt(id) })
    },
    depositOrders(pageNum, pageSize) {
      return post(url.recharge.orders, { pageNum, pageSize })
    },
    depositActivity() {
      return post(url.recharge.depositActivity)
    }
  }
})
